import MockAdapter from 'axios-mock-adapter'

import {mockStore} from '../mockStore'

import {numberRegEx, saveScenario, sleepResponse} from './utils'

import {GrindingCircuit, GrindingCircuitPayload} from '@settings/modules/plant-setup/types'

export const enableGrindingCircuitsEndpoints = (mock: MockAdapter) => {
  // GET grinding circuits
  mock.onGet(new RegExp(`plants/${numberRegEx}/grinding-circuits`)).reply(() => {
    const scenario = mockStore.scenario()
    const {grindingCircuits} = scenario.burglengenfeld
    return sleepResponse([200, grindingCircuits])
  })

  // POST create new grinding circuit
  mock.onPost(new RegExp(`plants/${numberRegEx}/grinding-circuits`)).reply((config) => {
    const scenario = mockStore.scenario()
    const grindingCircuit = JSON.parse(config.data as string) as GrindingCircuitPayload

    const {grindingCircuits} = scenario.burglengenfeld
    const newGrindingCircuit: GrindingCircuit = {
      ...grindingCircuit,
      id: grindingCircuits.length + 1
    }
    scenario.burglengenfeld.grindingCircuits = [...grindingCircuits, newGrindingCircuit]

    saveScenario(scenario)
    return sleepResponse([200, grindingCircuits])
  })

  // PUT update a grinding circuit
  mock
    .onPut(new RegExp(`plants/${numberRegEx}/grinding-circuits/${numberRegEx}$`))
    .reply((config) => {
      const scenario = mockStore.scenario()
      const grindingCircuit = JSON.parse(config.data as string) as GrindingCircuitPayload
      const grindingCircuitId = Number((config.url as string).split('/')[4])

      const {grindingCircuits} = scenario.burglengenfeld
      scenario.burglengenfeld.grindingCircuits = grindingCircuits.map((circuit) =>
        circuit.id === grindingCircuitId ? {...circuit, ...grindingCircuit} : circuit
      )

      saveScenario(scenario)
      return sleepResponse([200, grindingCircuits])
    })

  // DELETE delete a material
  mock
    .onDelete(new RegExp(`plants/${numberRegEx}/grinding-circuits/${numberRegEx}$`))
    .reply((config) => {
      const scenario = mockStore.scenario()
      const grindingCircuitId = Number((config.url as string).split('/')[4])

      const {grindingCircuits} = scenario.burglengenfeld
      scenario.burglengenfeld.grindingCircuits = grindingCircuits.filter(
        ({id}) => id !== grindingCircuitId
      )

      saveScenario(scenario)
      return sleepResponse([200, {}])
    })
}
